// extracted by mini-css-extract-plugin
export default {"tabs":"IntervalType_tabs__+CP78"};